import { reactive, ref } from '@vue/composition-api';
import { BoardEntryFile } from '@/models/apis/settouMessageBoard/settouMessageBoardResponse';
import { ModalPhoto, PhotoModalState } from '@/models/photoModal';
import { fetchFileAsObjectInfo } from '@/lib/fileHelper';
import { createInjection } from '@/lib/createInjection';

export interface UsePhotoModalResult {
  photoModalState: PhotoModalState;
  showPhotoModal: (images: BoardEntryFile[]) => Promise<void>;
  hidePhotoModal: () => void;
}

const { provide, inject } = createInjection<UsePhotoModalResult>('settouMessageBoard/usePhotoModal');

export function providePhotoModal(): void {
  provide(buildPhotoModal());
}

export function usePhotoModal(): UsePhotoModalResult {
  return inject();
}

// 添付写真モーダルの表示状態と写真の読み込みを担う composable。
function buildPhotoModal(): UsePhotoModalResult {
  const photoModalState = reactive<PhotoModalState>({
    shouldShowPhotoModal: false,
    title: '添付写真',
    photos: [],
  });
  const isLoadingPhotoModal = ref<boolean>(false);

  const showPhotoModal = async(images: BoardEntryFile[]): Promise<void> => {
    if (isLoadingPhotoModal.value) return;

    isLoadingPhotoModal.value = true;
    photoModalState.photos = [];
    try {
      for (let i = 0; i < images.length; i++) {
        const imageObjInfo = await fetchFileAsObjectInfo(images[i].file_path);
        if (!imageObjInfo || !imageObjInfo.url) continue;

        const photo: ModalPhoto = {
          id: images[i].id,
          photoTitle: String(i + 1),
          savedImage: imageObjInfo.url,
        };
        photoModalState.photos.push(photo);
      }
      photoModalState.shouldShowPhotoModal = true;
    } finally {
      isLoadingPhotoModal.value = false;
    }
  };
  const hidePhotoModal = (): void => {
    photoModalState.shouldShowPhotoModal = false;
  };

  return {
    photoModalState,
    showPhotoModal,
    hidePhotoModal,
  };
}
